import styled from "styled-components";
import CurrencyInput from 'react-currency-input-field';

export const Input = styled.input`
    height: 35px;
    width: 100%;
    border: 0.5px solid #CCC;
    color: ${props => props.theme.colors.primaryText};
    border-radius: 17.5px;
    padding: 0 17.5px;

    @media (min-width: 576px) {
        width: 80%;
    }

    @media (min-width: 767px) {
        width: 60%;
    }

    @media (min-width: 1200px) {
        width: 50%;
    }
`;

export const InputCurrency = styled(CurrencyInput)`
    height: 35px;
    width: 100%;
    border: 0.5px solid #CCC;
    color: ${props => props.theme.colors.primaryText};
    border-radius: 17.5px;
    padding: 0 17.5px;

    @media (min-width: 576px) {
        width: 80%;
    }

    @media (min-width: 767px) {
        width: 60%;
    }

    @media (min-width: 1200px) {
        width: 50%;
    }
`;